import { get } from 'lodash';
import { createConnector } from 'react-instantsearch-dom';

export default createConnector({
  displayName: 'JCAlgoliaInfiniteHits',

  getProvidedProps(props, searchState, searchResults) {
    const { results } = searchResults;

    this.allResults = this.allResults || [];
    this.previousPage = this.previousPage || 0;
    const currentRefinement = searchState.attributeForMyQuery || '';
    if (!results) {
      return {
        hits: [],
        facets: {},
        hasMore: false,
      };
    }

    const { hits, page, nbPages } = results;

    if (page === 0) {
      this.allResults = hits;
    } else if (page > this.previousPage) {
      this.allResults = [...this.allResults, ...hits];
    } else if (page < this.previousPage) {
      this.allResults = hits;
    }

    const lastPageIndex = nbPages - 1;
    const hasMore = page < lastPageIndex;

    this.previousPage = page;

    return {
      facets: get(results, '_rawResults.0.facets', {}),
      hits: this.allResults,
      hasMore,
      currentRefinement,
    };
  },

  getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setQueryParameters({
      page: searchState.page - 1,
    });
  },

  refine(props, searchState, nextRefinement) {
    return {
      ...searchState,
      page: searchState.page + 1,
      attributeForMyQuery: nextRefinement,
    };
  },
});
